import { render, staticRenderFns } from "./FolderDialog.vue?vue&type=template&id=304c81a2"
import script from "./FolderDialog.vue?vue&type=script&lang=js"
export * from "./FolderDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports